import { IPageFilters } from 'services/filters/filters.types'

export const ApiPathsWiki = {
  publicWiki: ({ page, limit, search, communityTag, category }: IPageFilters) =>
    `/wiki/public/all?page=${page}&limit=${limit}${search ? `&search=${search}` : ''}${
      communityTag ? `&filter.communityTag=$in:${communityTag}` : ''
    }${category ? `&filter.category=$in:${category}` : ''}`,
  wikiBySlug: (slug: string) => `/wiki/slug/${slug}`,
  countriesWithWikiList: '/wiki/countries/list',
  publicWikiIds: (page: number, limit: number) => `/wiki/public/all/ids?page=${page}&limit=${limit}`,
  bots: '/bots',
  addBotWiki: (type: 'news' | 'question') => `/bots/create/wiki/${type}`,
}
